import React from 'react';
import PageHero from '../../components/PageHero';
import AnimatedSection from '../../components/AnimatedSection';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function GeneralLiability() {
  return (
    <div className="bg-white">
      <PageHero 
        title="General Liability" 
        description="A ruthless defense mechanism against third-party claims, lawsuits, and reputational attacks."
        image="https://images.unsplash.com/photo-1584844284164-325fb08dc4ba?q=80&w=2070&auto=format&fit=crop"
      />
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <AnimatedSection>
              <div className="w-16 h-2 bg-red-600 mb-8"></div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-8 tracking-tight">Neutralize Threats.</h2>
              <p className="text-zinc-600 text-xl mb-8 font-light leading-relaxed">
                In a litigious world, a single claim can paralyze operations. Our elite General Liability coverage acts as a specialized legal shield, absorbing the financial shock of bodily injury, property damage, and vicious advertising disputes so you remain untouched.
              </p>
              <ul className="space-y-5 mb-12">
                {['Third-Party Bodily Injury Defense', 'Property Damage Restitution', 'Reputational Harm Mitigation', 'Intellectual Property Shielding'].map((item, i) => (
                  <motion.li whileHover={{ x: 5 }} key={i} className="flex items-center gap-4 text-zinc-800 font-medium text-lg">
                    <div className="bg-red-50 p-2 rounded-lg text-red-600"><SafeIcon icon={FiIcons.FiShield} /></div> {item}
                  </motion.li>
                ))}
              </ul>
              <Link to="/contact" className="inline-block bg-zinc-900 text-white px-8 py-4 rounded-full font-bold hover:bg-red-600 transition-colors shadow-xl uppercase tracking-wide text-sm">
                Deploy Liability Shield
              </Link>
            </AnimatedSection>
            <AnimatedSection delay={0.2} className="relative">
              <div className="absolute inset-0 bg-zinc-900 -translate-x-4 translate-y-4 rounded-3xl"></div>
              <img src="https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2024&auto=format&fit=crop" alt="Liability Defense Legal" className="relative z-10 rounded-3xl shadow-2xl w-full h-[600px] object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
}